import { render } from "./ironIcon.vue?vue&type=template&id=3d16d49f"
import script from "./ironIcon.vue?vue&type=script&lang=js"
export * from "./ironIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__